import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vShow as _vShow, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "movie-player-container" }
const _hoisted_2 = { class: "movie-player" }
const _hoisted_3 = { class: "top-bar view-mode-full" }
const _hoisted_4 = {
  key: 0,
  class: "ib ts"
}
const _hoisted_5 = {
  key: 1,
  class: "ib ts"
}
const _hoisted_6 = { class: "ib location ml4" }
const _hoisted_7 = { class: "ib road-name" }
const _hoisted_8 = { class: "ib direction" }
const _hoisted_9 = {
  key: 0,
  class: "ib place-name"
}
const _hoisted_10 = { class: "ib kp" }
const _hoisted_11 = {
  key: 2,
  class: "ib car-name ml4"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "toggle-button mr16" }
const _hoisted_16 = { class: "btn-group btn-group-toggle" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "row1" }
const _hoisted_19 = { class: "map-area" }
const _hoisted_20 = { class: "control-area ml8" }
const _hoisted_21 = { class: "mt8" }
const _hoisted_22 = { class: "map-elem-info-area full-mode mt8" }
const _hoisted_23 = {
  key: 0,
  class: "confirm-create"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "button-row mt8" }
const _hoisted_27 = { class: "sensor-chart-btn-area" }
const _hoisted_28 = {
  key: 0,
  class: "ifd-link-area full-mode"
}
const _hoisted_29 = { class: "row2 mt8" }
const _hoisted_30 = { class: "sensor-chart-area" }

import MoviePlayerControlArea from 'src/components/lib/MoviePlayerControlArea/index.vue';
import MovieMetaInfoArea from 'src/components/lib/MovieMetaInfoArea/index.vue';
import MapElemInfoNew from 'src/components/Top/mapElemInfoComponents/MapElemInfoNew.vue';
import MoviePlayerVideo from 'src/components/lib/MoviePlayer/MoviePlayerVideo.vue';
import ThreeAxisSensorChart from 'src/components/lib/ThreeAxisSensorChart/index.vue';
import ExtremeMap from 'src/components/lib/ExtremeMap/index.vue';
import type { BasicPlayerProps, BasicPlayerEmit } from 'src/models/moviePlayer';
import { dtFormat } from 'src/lib/dateHelper';
import { FULL_PLAYER_TYPE } from 'src/consts/movie_player';
import { useBasicPlayerState } from 'src/components/lib/MoviePlayer/BasicMoviePlayer/composables/useBasicPlayerState';
import { useBasicPlayer } from 'src/components/lib/MoviePlayer/BasicMoviePlayer/composables/useBasicPlayer';
import { useMoviePlayerDownloadFlags } from 'src/components/lib/MoviePlayer/composables/useMoviePlayerDownloadFlags';
import {
  useBasicPlayerPlayback,
} from 'src/components/lib/MoviePlayer/BasicMoviePlayer/composables/useBasicPlayerPlayback';
import { useMoviePlayerSensorChart } from 'src/components/lib/MoviePlayer/composables/useMoviePlayerSensorChart';
import { useMoviePlayerTagModal } from 'src/components/lib/MoviePlayer/composables/useMoviePlayerTagModal';
import { useMoviePlayerMapLinkage } from 'src/components/lib/MoviePlayer/composables/useMoviePlayerMapLinkage';
import { useMoviePlayerMovieList } from 'src/components/lib/MoviePlayer/composables/useMoviePlayerMovieList';
import { useMoviePlayerInfraDoctor } from 'src/components/lib/MoviePlayer/composables/useMoviePlayerInfraDoctor';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    movieLists: {},
    movieListId: {},
    extremeMapEssentials: {},
    parentGeoItemsMeta: {}
  },
  emits: ["close", "switch-to-compare-mode"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const playerState = useBasicPlayerState();
const {
  state,
  refExtremeMap,
  refTopBarArea,
  refVideoArea,
  refControlArea,
  refMoviePlayerVideos,
  refMetaInfoArea,
  masters,
} = playerState;

// 分割composableの構築順序: 後段は前段の関数をDIで受け取るため、この順序を変更すると未定義参照になる。
const download = useMoviePlayerDownloadFlags(state);
const playback = useBasicPlayerPlayback(state, { refMoviePlayerVideos, refControlArea });
const sensor = useMoviePlayerSensorChart(state, { seekByTimeText: playback.seekByTimeText });
const tagModal = useMoviePlayerTagModal(state, { pauseUI: playback.pauseUI });
const map = useMoviePlayerMapLinkage(state, {
  refExtremeMap, refMoviePlayerVideos, parentGeoItemsMeta: props.parentGeoItemsMeta,
  setCurrentMovie: playback.setCurrentMovie, pauseUI: playback.pauseUI,
});
const movieList = useMoviePlayerMovieList(state, {
  masters, refMetaInfoArea, setCurrentMovie: playback.setCurrentMovie, updateMap: map.updateMap,
  resetSensorChart: sensor.setSensorChartUIStateToDefault, playUI: playback.playUI,
});
const infraDoctor = useMoviePlayerInfraDoctor(state);

const sub = { download, playback, sensor, tagModal, map, movieList, infraDoctor };
const {
  compareModeTooltip,
  switchToCompareMode,
  closeMoviePlayer,
  shortcutKeyAction,
  onCurrentMovieListIdChangeBySelect,
} = useBasicPlayer(props, emit, playerState, sub);

__expose({
  shortcutKeyAction,
});

return (_ctx: any,_cache: any) => {
  const _component_TagModal = _resolveComponent("TagModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(movieList).isCurrentMovieListReady)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "top-bar-area",
            ref_key: "refTopBarArea",
            ref: refTopBarArea
          }, [
            _createElementVNode("div", _hoisted_3, [
              (!_unref(state).movieList.listSelection.showMovieListSelect)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "ts-loc-car-disp",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).movieList.listSelection.showMovieListSelect = true))
                  }, [
                    (!_unref(movieList).isCurrentMovieListSearchTypeRoute)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(dtFormat)(_unref(state).movieList.listSelection.currentMovieList?.startTs, 'yyyy/mm/dd HH:MM:SS')) + "~ ", 1))
                      : _createCommentVNode("", true),
                    (_unref(movieList).isCurrentMovieListSearchTypeRoute)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 再生時間 " + _toDisplayString(_unref(dtFormat)(_unref(state).movieList.listSelection.currentMovieList?.endTs, 'HH:MM:SS')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(state).movieList.listSelection.currentMovieList?.startKp.roadNameDispShort), 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(state).movieList.listSelection.currentMovieList?.startKp.direction), 1),
                      (_unref(state).movieList.listSelection.currentMovieList?.startKp.placeName !== 'main_line')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(state).movieList.listSelection.currentMovieList?.startKp.placeName), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_10, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-location-arrow" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_unref(state).movieList.listSelection.currentMovieList?.startKp.kp.toFixed(1)), 1)
                      ])
                    ]),
                    (!_unref(movieList).isCurrentMovieListSearchTypeRoute)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("span", null, " (車番: " + _toDisplayString(_unref(state).movieList.listSelection.currentMovieList?.carName) + ") ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(state).movieList.listSelection.showMovieListSelect)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).movieList.listSelection.currentMovieListId) = $event)),
                      class: "custom-select ml-select ib",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onCurrentMovieListIdChangeBySelect) && _unref(onCurrentMovieListIdChangeBySelect)(...args)))
                    }, [
                      (!_unref(movieList).isCurrentMovieListSearchTypeRoute)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(state).movieList.listSelection.currentMovieLists, (e) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: e.id,
                              value: e.id
                            }, _toDisplayString(e.dateLocationCarDisp), 9, _hoisted_13))
                          }), 128))
                        : _createCommentVNode("", true),
                      (_unref(movieList).isCurrentMovieListSearchTypeRoute)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(state).movieList.listSelection.currentMovieLists, (e) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: e.id,
                              value: e.id
                            }, _toDisplayString(e.dateLocationDisp), 9, _hoisted_14))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 544), [
                      [_vModelSelect, _unref(state).movieList.listSelection.currentMovieListId]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-secondary ml4",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(state).movieList.listSelection.showMovieListSelect = false))
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                    ]))])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "btn btn-info btn-sm active" }, [
                  _createElementVNode("input", {
                    type: "radio",
                    name: "options",
                    checked: "",
                    autocomplete: "off"
                  }),
                  _createTextVNode("三面 ")
                ], -1)),
                _withDirectives((_openBlock(), _createElementBlock("label", {
                  class: _normalizeClass(["btn btn-info btn-sm", {disabled: _unref(movieList).isCurrentMovieListSearchTypeRoute}])
                }, [
                  _createElementVNode("input", {
                    type: "radio",
                    name: "options",
                    disabled: _unref(movieList).isCurrentMovieListSearchTypeRoute,
                    autocomplete: "off",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(switchToCompareMode) && _unref(switchToCompareMode)(...args)))
                  }, null, 8, _hoisted_17),
                  _cache[15] || (_cache[15] = _createTextVNode("比較 ", -1))
                ], 2)), [
                  [
                    _directive_tooltip,
                    _unref(compareModeTooltip),
                    void 0,
                    { bottom: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "close-button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(closeMoviePlayer) && _unref(closeMoviePlayer)(...args)))
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("i", { class: "fas fa-times fa-2x" }, null, -1)
            ]))])
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "video-area",
        ref_key: "refVideoArea",
        ref: refVideoArea
      }, [
        _createElementVNode("div", {
          class: "videos",
          style: _normalizeStyle({ height: _unref(state).ui.styles.videoHeight })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(playback).vid1, _unref(playback).vid2, _unref(playback).vid3], (vid) => {
            return (_openBlock(), _createBlock(MoviePlayerVideo, {
              key: vid,
              ref_for: true,
              ref_key: "refMoviePlayerVideos",
              ref: refMoviePlayerVideos,
              vid: vid,
              "player-type": _unref(FULL_PLAYER_TYPE),
              "current-movie": _unref(state).movieList.current.currentMovie,
              "movie-file-url": _unref(playback).selectUrlForVid(vid),
              "is-current-movie-ready": _unref(state).movieList.current.isCurrentMovieReady,
              "is-downloading-movie-file": _unref(state).ui.isDownloadingMovieFile,
              "is-downloading-screenshot": _unref(state).ui.isDownloadingScreenshot,
              "video-control-properties": _unref(state).playback.videoControlProperties,
              "disable-volume": vid !== _unref(playback).vid2,
              "is-front": vid === _unref(playback).vid2,
              "sync-current-time": _unref(state).playback.currentTime,
              "title-bar-texts": _unref(state).playback.titleBarTexts,
              "has-continued-movies": _unref(movieList).hasContinuedMovies,
              "is-movie-ended": _unref(state).movieList.current.isMovieEnded,
              onStartDownloadMovieFile: _unref(download).onStartDownloadMovieFile,
              onFinishDownloadMovieFile: _unref(download).onFinishDownloadMovieFile,
              onStartDownloadScreenshot: _unref(download).onStartDownloadScreenshot,
              onFinishDownloadScreenshot: _unref(download).onFinishDownloadScreenshot,
              onVjsTimeUpdate: _unref(playback).onVjsTimeUpdate,
              onLoadedData: _unref(playback).onVjsLoadedData,
              onVjsError: _unref(playback).onVjsError,
              onPlay: _unref(playback).playUI,
              onPause: _unref(playback).pauseUI,
              onPlayPreviousMovie: _unref(playback).playPreviousMovie,
              onPlayNextMovie: _unref(playback).playNextMovie,
              onTickForward: _unref(playback).tickMovieForward,
              onTickBackward: _unref(playback).tickMovieBackward,
              onSeekChange: _unref(playback).emitSeekChange,
              onPrepared: _unref(playback).onVjsPrepared,
              onPlayContinuedMovies: _unref(movieList).onPlayContinuedMovies,
              onPlaymodeChange: _unref(playback).playModeChange
            }, null, 8, ["vid", "player-type", "current-movie", "movie-file-url", "is-current-movie-ready", "is-downloading-movie-file", "is-downloading-screenshot", "video-control-properties", "disable-volume", "is-front", "sync-current-time", "title-bar-texts", "has-continued-movies", "is-movie-ended", "onStartDownloadMovieFile", "onFinishDownloadMovieFile", "onStartDownloadScreenshot", "onFinishDownloadScreenshot", "onVjsTimeUpdate", "onLoadedData", "onVjsError", "onPlay", "onPause", "onPlayPreviousMovie", "onPlayNextMovie", "onTickForward", "onTickBackward", "onSeekChange", "onPrepared", "onPlayContinuedMovies", "onPlaymodeChange"]))
          }), 128))
        ], 4)
      ], 512),
      _createElementVNode("div", {
        class: "info-area mt16",
        style: _normalizeStyle({ height: _unref(state).ui.styles.infoHeight })
      }, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(ExtremeMap, {
              ref_key: "refExtremeMap",
              ref: refExtremeMap,
              "map-essentials": __props.extremeMapEssentials,
              "disable-movie-layer-interaction": true,
              onClickMap: _unref(map).seekByMapClick,
              onClickItem: _unref(map).onMapItemClicked,
              onAllDeselected: _unref(map).onMapAllDeselected
            }, null, 8, ["map-essentials", "onClickMap", "onClickItem", "onAllDeselected"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createVNode(MoviePlayerControlArea, {
                ref_key: "refControlArea",
                ref: refControlArea,
                "control-area-id": "basic",
                "view-mode": "full",
                "play-speed": _unref(state).playback.videoControlProperties.playSpeed,
                "is-play-backward": _unref(state).playback.videoControlProperties.isPlayBackward,
                "is-playing": _unref(state).playback.isPlaying,
                "current-time-disp": _unref(movieList).playerControlCurrentTimeDisp,
                "start-time-disp": _unref(state).movieList.timeDisp.startTimeDisp,
                "end-time-disp": _unref(state).movieList.timeDisp.endTimeDisp,
                "seek-min": _unref(state).playback.seek.min,
                "seek-max": _unref(state).playback.seek.max,
                "seek-current": _unref(state).playback.seek.current,
                "seek-step": _unref(state).playback.seek.step,
                onPlay: _unref(playback).playMovie,
                onPause: _unref(playback).pauseMovie,
                onSeekChange: _unref(playback).seekBySeekBar,
                onTickBackward: _unref(playback).tickMovieBackward,
                onTickForward: _unref(playback).tickMovieForward,
                onPlayPreviousMovie: _unref(playback).playPreviousMovie,
                onPlayNextMovie: _unref(playback).playNextMovie,
                onSetPlaySpeed: _unref(playback).setPlaySpeed,
                onSetVolume: _unref(playback).setVolume,
                onPlaymodeChange: _unref(playback).playModeChange
              }, null, 8, ["play-speed", "is-play-backward", "is-playing", "current-time-disp", "start-time-disp", "end-time-disp", "seek-min", "seek-max", "seek-current", "seek-step", "onPlay", "onPause", "onSeekChange", "onTickBackward", "onTickForward", "onPlayPreviousMovie", "onPlayNextMovie", "onSetPlaySpeed", "onSetVolume", "onPlaymodeChange"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_unref(movieList).isCurrentMovieListReady)
                ? (_openBlock(), _createBlock(MovieMetaInfoArea, {
                    key: 0,
                    ref_key: "refMetaInfoArea",
                    ref: refMetaInfoArea,
                    "view-mode": "full",
                    movie: _unref(state).movieList.current.currentMovie,
                    "movie-geo-index": _unref(state).geo.currentMgi,
                    "movie-current-dt": _unref(state).geo.currentMovieCurrentDt,
                    "enable-sensor-chart": false,
                    "enable-time-seek": !_unref(movieList).isCurrentMovieListSearchTypeRoute,
                    "location-disp": _unref(state).geo.locationDisp,
                    onStartTimeEdit: _unref(playback).pauseUI,
                    onMoveToTime: _unref(playback).seekByTimeText,
                    onEditMovieTags: _unref(tagModal).startEditMovieTags
                  }, null, 8, ["movie", "movie-geo-index", "movie-current-dt", "enable-time-seek", "location-disp", "onStartTimeEdit", "onMoveToTime", "onEditMovieTags"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (!_unref(state).geo.mapElemInfo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("img", {
                      class: "map-elem-icon",
                      src: _unref(map).mapElemIconPath
                    }, null, 8, _hoisted_24),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(map).startCreateMapElem && _unref(map).startCreateMapElem(...args))),
                      disabled: !_unref(state).geo.currentMgi
                    }, " 現在位置に付箋を追加 ", 8, _hoisted_25)
                  ]))
                : (_openBlock(), _createBlock(MapElemInfoNew, {
                    key: 1,
                    elem: _unref(state).geo.mapElemInfo,
                    "visible-layers": _unref(map).visibleGeoItemLayers,
                    "force-show-cancel-button": true,
                    "create-failed": _unref(state).geo.createMapElemFailed,
                    onCreate: _unref(map).createMapElem,
                    onCancelEdit: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).geo.mapElemInfo = null))
                  }, null, 8, ["elem", "visible-layers", "create-failed", "onCreate"]))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                (!_unref(movieList).isCurrentMovieListSearchTypeRoute)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_unref(state).ui.showSensorChart)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-sm btn-secondary",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(sensor).openSensorChart && _unref(sensor).openSensorChart(...args)))
                          }, " 三軸センサー表示 "))
                        : _createCommentVNode("", true),
                      (_unref(state).ui.showSensorChart)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-sm btn-secondary",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(sensor).closeSensorChart && _unref(sensor).closeSensorChart(...args)))
                          }, " 三軸センサー非表示 "))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (!!_unref(infraDoctor).ifdLink)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-info",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(infraDoctor).openInfraDoctor && _unref(infraDoctor).openInfraDoctor(...args)))
                    }, " インフラドクターを開く ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _withDirectives(_createElementVNode("div", _hoisted_30, [
            _createVNode(ThreeAxisSensorChart, {
              "sensor-data": _unref(state).ui.sensorData,
              onClick: _unref(sensor).onSensorChartClick
            }, null, 8, ["sensor-data", "onClick"])
          ], 512), [
            [_vShow, _unref(state).ui.showSensorChart]
          ])
        ])
      ], 4)
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "movie-player-backdrop" }, null, -1)),
    (_unref(state).ui.movieTagModal.show)
      ? (_openBlock(), _createBlock(_component_TagModal, {
          key: 0,
          class: "z-index-3000",
          title: "動画タグの編集",
          modelValue: _unref(state).ui.movieTagModal.tags,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).ui.movieTagModal.tags) = $event)),
          onClose: _unref(tagModal).updateMovieTags,
          onDismiss: _cache[12] || (_cache[12] = ($event: any) => (_unref(state).ui.movieTagModal.show = false))
        }, null, 8, ["modelValue", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}
}

})